import { useEffect, useState } from 'react';
// Components
import { Page } from '@/components/common';
import { DashboardNodes, NodePageHeader } from './components';
// Hooks
import { useAuth } from '@/hooks/useAuth';
import { useWallet } from '@/hooks/useWallet';
import { useAppInfo } from '@/providers/AppInfoProvider';
// Utils
import { getActiveLicenses } from '@/resources/ug.resource';

const initNodeState = {
  v1NodesOnline: 0,
  v2NodesOnline: 0,
  totalOnline: 0,
  needOnline: 0,
};

function Nodes() {
  const { fetcher } = useAuth();
  const { memberRewards, handleSetNavBadges } = useAppInfo();
  const { hasAnyEthWallet, walletCoinState, coreWalletCoinState } = useWallet();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [nodeState, setNodeState] = useState(initNodeState);

  useEffect(() => {
    handleFetchNodeData();
  }, []);

  const handleFetchNodeData = () => {
    fetcher(getActiveLicenses())
      .then(setNodeState)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  };

  const isWalletSetup = hasAnyEthWallet;
  const isWalletLoading = walletCoinState.loading && coreWalletCoinState.loading;

  return (
    <Page>
      <NodePageHeader
        isWalletSetup={isWalletSetup}
        isWalletLoading={isWalletLoading}
        memberRewards={memberRewards}
        handleSetNavBadges={handleSetNavBadges}
      />
      <DashboardNodes
        error={error}
        handleFetchNodeData={handleFetchNodeData}
        loading={loading}
        nodeState={nodeState}
      />
      {/* <FAQ smartNode={smartNode} liteNode={liteNode} /> */}
    </Page>
  );
}

Nodes.protectedRoute = true;

export default Nodes;
